export const pageSx = {
  px: { xs: 2, md: 4 },
  pb: 0.5,
};

export const paperSx = {
  p: { xs: 3, md: 5 },
  borderRadius: "20px",
  border: "1px solid #e2e8f0",
  boxShadow: "0 10px 40px rgba(15, 23, 42, 0.04)",
  backgroundColor: "#ffffff",
};

export const textFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#fff",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#cbd5e1",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#00c7db",
      borderWidth: 1.5,
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#e2e8f0",
  },
  "& .MuiInputLabel-root": {
    color: "#64748b",
    fontWeight: 500,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#00c7db",
  },
};
